import { render } from "./OrgVouchers.vue?vue&type=template&id=2b237383&scoped=true"
import script from "./OrgVouchers.vue?vue&type=script&lang=js"
export * from "./OrgVouchers.vue?vue&type=script&lang=js"

import "./OrgVouchers.vue?vue&type=style&index=0&id=2b237383&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b237383"]])

export default __exports__